<template>
  <ul>
    <li class="dates">
      {{ $tc('booking.default', 1) }}
      {{ $t('_period.from') }} {{ formatDate(booking.arrival_date) }}
      {{ $t('_period.to') }} {{ formatDate(booking.departure_date) }}
    </li>

    <li class="destination">
      {{ $t('_time.to') }} {{ booking.destination }}
    </li>

    <li class="travellers" v-if="booking.travellers">
      {{ $t('_for') }} {{ booking.travellers }}
    </li>
  </ul>
</template>

<script>
import formatter from '@/components/global/mixins/formatterMethods'

export default {
  mixins: [formatter],

  props: {
    booking: Object
  }
}
</script>
